(function () {
  if (window.__owaCartRecommendationsInit) return;
  window.__owaCartRecommendationsInit = true;

  const SELECTORS = {
    section: '[data-owa-cart-recs-section]',
    trigger: '[data-owa-cart-rec-trigger]',
    productJson: '[data-owa-cart-rec-product-json]',
    modal: '[data-owa-cart-rec-modal]',
    close: '[data-owa-cart-rec-close]',
    title: '[data-owa-cart-rec-modal-title]',
    image: '[data-owa-cart-rec-modal-image]',
    price: '[data-owa-cart-rec-modal-price]',
    options: '[data-owa-cart-rec-modal-options]',
    error: '[data-owa-cart-rec-modal-error]',
    submit: '[data-owa-cart-rec-modal-submit]',
  };

  const CART_ADD_URL =
    (window.routes && window.routes.cart_add_url) ||
    (window.theme && window.theme.routes && window.theme.routes.cart_add_url) ||
    '/cart/add.js';

  function formatMoney(cents) {
    return new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR',
    }).format((Number(cents) || 0) / 100);
  }

  function getFirstAvailableVariant(product) {
    return product.variants.find((variant) => variant.available) || product.variants[0] || null;
  }

  class OwaCartRecommendations {
    constructor(section) {
      this.section = section;
      this.modal = section.querySelector(SELECTORS.modal);
      this.modalTitle = section.querySelector(SELECTORS.title);
      this.modalImage = section.querySelector(SELECTORS.image);
      this.modalPrice = section.querySelector(SELECTORS.price);
      this.modalOptions = section.querySelector(SELECTORS.options);
      this.modalError = section.querySelector(SELECTORS.error);
      this.modalSubmit = section.querySelector(SELECTORS.submit);
      this.modalSubmitLabel = section.dataset.owaCartRecModalSubmitLabel || 'Voeg toe aan winkelmand';
      this.soldOutLabel = section.dataset.owaCartRecSoldOutLabel || 'Uitverkocht';
      this.loadingLabel = section.dataset.owaCartRecLoadingLabel || 'Toevoegen...';
      this.retryLabel = section.dataset.owaCartRecRetryLabel || 'Probeer opnieuw';
      this.activeProduct = null;
      this.selectedOptions = [];
      this.lastTrigger = null;

      this.handleSectionClick = this.handleSectionClick.bind(this);
      this.handleModalClick = this.handleModalClick.bind(this);
      this.handleOptionChange = this.handleOptionChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);

      section.addEventListener('click', this.handleSectionClick);
      this.modal.addEventListener('click', this.handleModalClick);
      this.modalOptions.addEventListener('change', this.handleOptionChange);
      this.modalSubmit.addEventListener('click', this.handleSubmit);
      document.addEventListener('keydown', this.handleKeydown);
    }

    handleSectionClick(event) {
      const trigger = event.target.closest(SELECTORS.trigger);
      if (!trigger || trigger.disabled) return;

      const product = this.getProductData(trigger);
      if (!product) return;

      this.lastTrigger = trigger;

      if (trigger.dataset.owaCartRecMode === 'single') {
        this.addToCart(trigger.dataset.owaCartRecVariantId, trigger);
        return;
      }

      event.preventDefault();
      this.openModal(product);
    }

    handleModalClick(event) {
      if (event.target.closest(SELECTORS.close)) {
        this.closeModal();
      }
    }

    handleOptionChange(event) {
      const select = event.target.closest('select[data-owa-cart-rec-option-index]');
      if (!select || !this.activeProduct) return;

      const index = Number(select.dataset.owaCartRecOptionIndex);
      this.selectedOptions[index] = select.value;
      this.syncModal();
    }

    handleSubmit() {
      const variant = this.getSelectedVariant();
      if (!variant || !variant.available) {
        this.showError('Deze combinatie is momenteel niet beschikbaar.');
        return;
      }

      this.addToCart(variant.id, this.modalSubmit, true);
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && !this.modal.hidden) {
        this.closeModal();
      }
    }

    getProductData(trigger) {
      const container = trigger.closest('.owa-cart-recs__card-actions');
      const jsonNode = container?.querySelector(SELECTORS.productJson);
      if (!jsonNode) return null;

      try {
        return JSON.parse(jsonNode.textContent);
      } catch (error) {
        console.error('OWA cart recommendations JSON parse failed', error);
        return null;
      }
    }

    openModal(product) {
      this.activeProduct = product;
      const defaultVariant = getFirstAvailableVariant(product);
      this.selectedOptions = defaultVariant?.options ? [...defaultVariant.options] : [];

      this.modalTitle.textContent = product.title || '';
      this.modalImage.src = product.featuredImage || '';
      this.modalImage.alt = product.title || '';
      this.modalError.hidden = true;
      this.modalError.textContent = '';

      this.renderOptions();
      this.syncModal();

      this.modal.hidden = false;
      document.body.classList.add('owa-cart-recs-modal-open');
    }

    closeModal() {
      this.modal.hidden = true;
      document.body.classList.remove('owa-cart-recs-modal-open');
      this.activeProduct = null;
      this.selectedOptions = [];
      this.modalSubmit.disabled = false;
      if (this.lastTrigger) this.lastTrigger.focus();
    }

    renderOptions() {
      if (!this.activeProduct) return;

      this.modalOptions.innerHTML = '';
      this.activeProduct.options.forEach((option, index) => {
        const wrapper = document.createElement('div');
        wrapper.className = 'owa-cart-recs-modal__option';

        const label = document.createElement('label');
        label.className = 'owa-cart-recs-modal__option-label';
        label.textContent = option.name;
        label.setAttribute('for', `OwaCartRecsOption-${this.activeProduct.id}-${index}`);

        const select = document.createElement('select');
        select.className = 'owa-cart-recs-modal__option-select';
        select.id = `OwaCartRecsOption-${this.activeProduct.id}-${index}`;
        select.dataset.owaCartRecOptionIndex = String(index);

        option.values.forEach((value) => {
          const optionNode = document.createElement('option');
          optionNode.value = value;
          optionNode.textContent = value;
          optionNode.selected = this.selectedOptions[index] === value;
          select.appendChild(optionNode);
        });

        wrapper.appendChild(label);
        wrapper.appendChild(select);
        this.modalOptions.appendChild(wrapper);
      });
    }

    getSelectedVariant() {
      if (!this.activeProduct) return null;

      return (
        this.activeProduct.variants.find((variant) => {
          return variant.options.every((value, index) => value === this.selectedOptions[index]);
        }) || null
      );
    }

    syncModal() {
      const variant = this.getSelectedVariant();
      if (!variant) {
        this.modalPrice.textContent = '';
        this.modalSubmit.disabled = true;
        this.showError('Kies een geldige combinatie om verder te gaan.');
        return;
      }

      const priceMarkup =
        variant.compareAtPrice && Number(variant.compareAtPrice) > Number(variant.price)
          ? `${formatMoney(variant.price)} <s>${formatMoney(variant.compareAtPrice)}</s>`
          : formatMoney(variant.price);

      this.modalPrice.innerHTML = priceMarkup;
      this.modalSubmit.disabled = !variant.available;
      this.modalSubmit.textContent = variant.available ? this.modalSubmitLabel : this.soldOutLabel;

      if (variant.available) {
        this.modalError.hidden = true;
        this.modalError.textContent = '';
      } else {
        this.showError('Deze combinatie is momenteel niet beschikbaar.');
      }
    }

    showError(message) {
      this.modalError.hidden = false;
      this.modalError.textContent = message;
    }

    async addToCart(variantId, button, closeAfterAdd = false) {
      if (!variantId || !button) return;

      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = this.loadingLabel;

      try {
        const response = await fetch(CART_ADD_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1,
              },
            ],
          }),
        });

        if (!response.ok) {
          throw new Error('Cart add failed');
        }

        if (closeAfterAdd) {
          this.closeModal();
        }

        window.location.reload();
      } catch (error) {
        console.error('OWA cart recommendation add failed', error);
        if (closeAfterAdd) {
          this.showError('Toevoegen is niet gelukt. Probeer het opnieuw.');
        } else {
          button.textContent = this.retryLabel;
        }
      } finally {
        if (!closeAfterAdd) {
          button.disabled = false;
          if (button.textContent !== this.retryLabel) {
            button.textContent = originalText;
          }
        } else {
          this.modalSubmit.disabled = false;
          if (this.modalSubmit.textContent === this.loadingLabel) {
            this.modalSubmit.textContent = originalText;
          }
        }
      }
    }
  }

  function init() {
    document.querySelectorAll(SELECTORS.section).forEach((section) => {
      if (section.__owaCartRecommendationsInstance) return;
      section.__owaCartRecommendationsInstance = new OwaCartRecommendations(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
